import DriveService from "../../../../../services/drive-service";
import Rule from "../../../../common/rule";

export default class EndDrive extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return ruleContext.driveEnd?.isActive;
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        await DriveService.endDrive(gameContext, ruleContext.driveEnd);
    }
}
